/**
 * Centered icon + two-line copy for Data Hub confirmation / success / error modals.
 * Line 1: short black headline (~16px). Line 2: grey detail.
 */
import type { ReactNode } from "react";

import type { LucideIcon } from "lucide-react";

type Tone = "info" | "warning" | "danger" | "success";

const toneClass: Record<Tone, string> = {
  info: "text-violet-600",
  warning: "text-amber-500",
  danger: "text-red-500",
  success: "text-green-600",
};

export function ConfirmModalBody({
  icon: Icon,
  tone = "info",
  headline,
  detail,
}: {
  icon: LucideIcon;
  tone?: Tone;
  headline: string;
  detail: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 py-2 text-center">
      <Icon className={`h-10 w-10 ${toneClass[tone]}`} strokeWidth={1.75} />
      <div className="space-y-1.5 px-1">
        <p className="m-0 text-base font-medium leading-snug text-black">
          {headline}
        </p>
        <p className="m-0 text-sm leading-relaxed text-gray-500">{detail}</p>
      </div>
    </div>
  );
}
